import React, { useContext, useEffect, useState } from 'react'
import LoginContext from "../Context/Logincontext"
import Nav1 from '../Component/Nav/Nav1'
import { NavLink } from 'react-router-dom'
import "./../styles/AddProduct.css"
import '../styles/AddClient.css'
import '../styles/AddCompositeProduct.css'
import Swal from 'sweetalert2'
import CloseButton from '../Component/CloseButton'
import LogoComponent from '../Component/LogoComponent'
import { urlApiServer } from '../Config/Config'

const AddProduct = () => {
    const urlPostProduct = urlApiServer + "addproduct";

    const [name, setName] = useState('')
    const [laborPrice, setLaboralPrice] = useState(null);
    const [unit, setUnit] = useState(null);
    const [vat, setVat] = useState(null);
    const [totalPrice, setTotalPrice] = useState('');
    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")
    const [utility, setUtility] = useState('');

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        setName(name)
    }

    async function handleLaborPrice(e) {
        const laborPrice = e.target.value.replace(/[^0-9-._]/g, '');
        setLaboralPrice(laborPrice);
    }

    async function handleUnit(e) {
        const unit = e.target.value;
        setUnit(unit)
    }

    async function handleVat(e) {
        const vat = e.target.value.replace(/[^0-9.]/g, '');
        setVat(vat);
    }

    async function handleUtility(e) {
        const utility = e.target.value.replace(/[^0-9.]/g, '');
        setUtility(utility);
    }


    async function uploadInventory() {
        const data = JSON.stringify({
            empresa: infoUser.company,
            product: name,
            material: null,
            long: null,
            caliber: null,
            price: laborPrice,
            iva: vat,
            modeljson: null,
            Model: null,
            image: null,
            ancho: null,
            unit: unit,
            cantidad: 1,
            utility: utility
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'POST',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(urlPostProduct, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (dataResponse.status === 560) {
                    Swal.fire({
                        icon: 'error',
                        text: 'Ha ocurrido un problema al intentar crear un producto, si el error persiste contacte con un administrador de la plataforma',
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                    })
                } else {
                    Swal.fire({
                        icon: 'success',
                        text: 'Se ha creado el producto correctamente',
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = './Productos';
                        }
                    })
                }
            })
    }

    const calculateTotalPrice = () => {
        // 2. Obtener valores base
        const labor = parseFloat(laborPrice) || 0;
        const vatPercentage = parseFloat(vat) || 0;
        const vatUtility = parseFloat(utility) || 0;

        // 3. Calcular subtotal (mano de obra + materiales)
        const subtotal = labor;

        // 4. Calcular total con IVA y utilidad
        const totalWithVat = subtotal * (1 + vatPercentage / 100) * (1 + vatUtility / 100);

        setTotalPrice(totalWithVat.toFixed(2));
    };

    useEffect(() => {
        calculateTotalPrice();
    }, [laborPrice, vat, utility]); // Añade utility aquí


    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">CREAR PRODUCTO</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoAdd'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>AGREGAR PRODUCTO</p>
                                            <p className='personalInformationEdit'>Producto</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={name}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del producto <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        value={laborPrice}
                                                        name="laborPrice"
                                                        id="laborPrice"
                                                        onChange={handleLaborPrice}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Precio del producto <em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <select
                                                        type="text"
                                                        value={unit}
                                                        name="unit"
                                                        id="unit"
                                                        onChange={handleUnit}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    >
                                                        <option value="">Unidad: </option>
                                                        <option value="U">U (Unidad)</option>
                                                        <option value="M">M (Metros)</option>
                                                        <option value="M2">M2 (Metros Cuadrados)</option>
                                                        <option value="C">C (Centimetros)</option>
                                                        <option value="P">P (Pulgadas)</option>
                                                        <option value="K">K (Kilogramos)</option>
                                                        <option value="G">G (Gramos)</option>
                                                        <option value="L">L (Libras)</option>
                                                        <option value="LT">LT (Litros)</option>
                                                        <option value="R">R (Radianes)</option>
                                                        <option value="R">S (Segundos)</option>
                                                        <option value="H">H (Horas)</option>
                                                        <option value="Dia/s">Dias</option>
                                                        <option value="Mes/es">Meses</option>
                                                        <option value="Año/s">Años</option>
                                                    </select>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <select
                                                        type="text"
                                                        value={vat}
                                                        name="vat"
                                                        id="vat"
                                                        onChange={handleVat}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    >
                                                        <option value="">Iva: </option>
                                                        <option value="0">0%</option>
                                                        <option value="5">5%</option>
                                                        <option value="16">16%</option>
                                                        <option value="19">19%</option>
                                                    </select>
                                                </div>

                                            </div>
                                            <div className='containerNameClient'>
                                                <div className='containerNameClient'>
                                                    <div className="inputClientContainer">
                                                        <input
                                                            type="number"
                                                            value={utility}
                                                            name="utility"
                                                            id="utility"
                                                            placeholder=" "
                                                            className="inputCLient"
                                                            onChange={handleUtility}
                                                        />
                                                        <label htmlFor="utility">Utilidad (%)</label>
                                                    </div>
                                                    <div className="inputClientContainer">
                                                        <input
                                                            type="number"
                                                            value={totalPrice}
                                                            name="totalPrice"
                                                            id="totalPrice"
                                                            placeholder=" "
                                                            className="inputCLient"
                                                            readOnly
                                                        />
                                                        <label htmlFor="name">
                                                            Precio total
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' to="/Producto_Compuesto"><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={uploadInventory} className='Textregister'><button className="button neon_Effect"><p>Agregar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )
}

export default AddProduct